var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"iframe"},[_c('iframe',{ref:"AIIFrame",staticClass:"iframeAi",attrs:{"src":_vm.src,"frameborder":"0"},on:{"load":_vm.onIframeLoad}})])])}
var staticRenderFns = []

export { render, staticRenderFns }